// The example CSV the Import-users tab hands out. The legacy app never shipped
// one — its importer was a bare file picker and users had to know the columns
// (git bc2fa128, `importUserFileHeaders`) — so this file is the first actual
// template, authored to the rewrite's contract: the legacy required four
// (First/Last Name, Country Code, Phone Number) plus the optional profile
// fields the Add-person form takes.
//
// Column names and order come from PEOPLE_CSV_COLUMNS in parsePeopleCsv.ts —
// the validator's own spec — so the file we hand out and the rules that will
// check it cannot drift apart. Both sample rows pass validatePeopleCsv.
//
// The contents are DATA, not copy — a filled-in template is written to the
// backend verbatim — so every value stays literal English and none of it goes
// through i18n (same rule as the data source template).

import { PEOPLE_CSV_COLUMNS } from './parsePeopleCsv';

export const PEOPLE_TEMPLATE_FILE_NAME = 'midani-people-template.csv';

/** Sample values keyed like the columns; two rows, the second exercising the
 *  optional blanks (no email, no nationality). Dial codes and option values
 *  must be ones the validator accepts (countries.ts / personFields.ts). */
const SAMPLE_ROWS: string[][] = [
  [
    'Rana',
    'Saleh',
    '+966',
    '551234567',
    'rana@coastalgroup.co',
    'Facilities',
    'Full-time',
    '1098234771',
    '2028-04-30',
    '1994-06-12',
    'Saudi',
  ],
  [
    'Yusuf',
    'Omar',
    '+966',
    '558823017',
    '',
    'Maintenance',
    'Contract',
    '2233114455',
    '2027-11-02',
    '1990-03-21',
    '',
  ],
];

/** RFC 4180 quoting — a cell needs it once it contains a comma, a quote or a
 *  line break, and an inner quote doubles. */
const escapeCell = (value: string): string =>
  /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

const toRow = (cells: string[]): string => cells.map(escapeCell).join(',');

/** Build the template. CRLF endings — Excel is the likely destination and the
 *  parser reads either. */
export const buildPeopleTemplateCsv = (): string => {
  const rows = [toRow(PEOPLE_CSV_COLUMNS.map((column) => column.label)), ...SAMPLE_ROWS.map(toRow)];
  return `${rows.join('\r\n')}\r\n`;
};
